// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.push-item__hint[data-v-a0c748be] {\n  white-space: normal;\n}\n", ""]);
// Exports
module.exports = exports;
